<template>
    <div>
        <el-form :inline="true">
            <el-form-item>
                <el-date-picker v-model="time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"/>
            </el-form-item>
            <el-form-item>
                <el-input style="width: max-content" v-model="coinType"/>
                <el-button type="success" @click="addCoin()">添加</el-button>
                <el-button type="primary"@click="queryStatistic()">查询</el-button>
            </el-form-item>
        </el-form>
        <p>当前超级合约币种：{{coinTypes}}</p>

        <el-table :data="list">
            <el-table-column label="币种" prop="coinType"/>
            <el-table-column label="人数" prop="usrCnt"/>
            <el-table-column label="订单量" prop="orderCnt"/>
            <el-table-column label="盈亏" prop="profit"/>
            <el-table-column label="手续费" prop="fee"/>
            <el-table-column label="时间" prop="updateTime"/>
        </el-table>
    </div>
</template>

<script>
    import api from "../api";
    export default {
        name: "ProfitStatistic",
        data() {
            return {
                time: [],
                coinType:'',
                coinTypes:[],
                list:[]
            }
        },
        methods:{
            queryStatistic() {
                let data = {};
                if (!this.time[0]) {
                   return this.$message.error('时间参数不能为空');
                }
                data.startTime = this.time[0];
                data.endTime = this.time[1];
                data.coinType = JSON.stringify(this.coinTypes);
               api.contractStatisticProfit(data).then(response =>{
                   this.list = response.data;
               })
            },

            addCoin(){
                this.coinTypes.push(this.coinType);
                this.coinType = '';
            }
        }
    }
</script>

<style scoped>

</style>
